module.exports = __webpack_public_path__ + "img/02-mobile.55d43b6d.jpg";